import React from "react";
import ReactDOM from "react-dom";
import { DataGrid, Button } from "devextreme-react";
import { Column, HeaderFilter } from "devextreme-react/ui/data-grid";
import HeaderTooltip from "../../../../../Shared/headerTooltip";
import NoDataComponent from "../../../../../Shared/noDataImage";

class Denuncias extends React.PureComponent {
  render() {
    return (
      <DataGrid
        showBorders={false}
        showColumnLines={false}
        showRowLines={false}
        rowAlternationEnabled
        className="custom-table height-min cursor-disabled color"
        noDataText=""
        dataSource={this.props.data}
        onContentReady={(e) => {
          if (e.component.totalCount() === 0) {
            const config = {};
            config.addClass = "table-margin-detalle";
            const noDataSpan = e.component.element().querySelector(".dx-scrollable-wrapper");
            ReactDOM.render(<NoDataComponent config={config} message="Sin denuncias" />, noDataSpan);
          }
        }}
      >
        <HeaderFilter visible texts={{ cancel: "Cancelar", emptyValue: "Sin resultados", ok: "Aceptar" }} />
        <Column
          dataField="Tipo"
          calculateDisplayValue={(data) => data.TipoDenuncia || "S/D"}
          headerCellTemplate={(element, row) => ReactDOM.render(<HeaderTooltip
            id="tooltipEvaluaciones"
            headerText="Tipo denuncia"
            widthprops={360}
            toolTipText="DIAT: Denuncia individual de accidente del trabajador."
            toolTipText2="DIEP: Denuncia indivitual de enfermedad profesional."

          />, element)}
        />
        <Column
          dataField="FechaDenuncia"
          caption="Fecha de la denuncia"
          format="dd/MM/yyyy"
          sortIndex={0}
          sortOrder="desc"
          calculateDisplayValue={(data) => data.FechaDenuncia || "S/D"}
        />
        <Column dataField="Estado" caption="Estado" calculateDisplayValue={(data) => data.Estado || "S/D"} />
        <Column
          caption=""
          allowFiltering={false}
          cellComponent={(props) => (
            <React.Fragment>
              {props.data.Estado === "Pendiente" && <Button
                text="Enviar"
                type="default"
                className="slimButton"
              />}
              {props.data.Estado === "Enviada" && <Button
                text="Reenviar"
                type="success"
                className="slimButton"
              />}
            </React.Fragment>
          )}
        />
        <Column
          caption=""
          allowFiltering={false}
          cellComponent={(props) => (
            <React.Fragment>
              {props.data.Estado !== "Pendiente" && <Button
                text="Ver"
                type="success"
                className="slimButton"
                onClick={() => this.props.handleViewDenuncia(props.data.IdSiniestro, props.data.idDocumento)}
              />}
            </React.Fragment>
          )}
        />
      </DataGrid>
    );
  }
}

export default Denuncias;
